import $ from 'jquery';

const init = () => {
  $(document).ready(function () {
    $('select:not(.prototype-select)').not('#gform_12 select').select2({
      minimumResultsForSearch: -1,
      width: 'resolve',
    });
  });

  // find all disabled classes
  // loop through them run function
  const disabled = document.querySelectorAll('.disabled input');

  if (disabled.length > 0) {
    disabled.forEach((label) => {
      DisableForm(label);
    });
  }
};

function DisableForm(DisableForm) {
  DisableForm.setAttribute('readonly', 'readonly');
  // DisableForm.setAttribute("disabled","disabled");
}

export default {
  init,
};
